import * as React from 'react';
import { forwardRef } from 'react';

var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SvgOpenNew24 = function SvgOpenNew24(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7V17L3.00488 17.2061C3.11211 19.3194 4.85996 21 7 21H17C19.2091 21 21 19.2091 21 17V13.4141H19.5V17C19.5 18.3807 18.3807 19.5 17 19.5H7C5.70566 19.5 4.64082 18.5164 4.5127 17.2559L4.5 17V7C4.5 5.61929 5.61929 4.5 7 4.5H10.5V3H7C4.79086 3 3 4.79086 3 7ZM20.25 10.5C20.6642 10.5 21 10.1642 21 9.75V3.75C21 3.33579 20.6642 3 20.25 3H14.25C13.8358 3 13.5 3.33579 13.5 3.75C13.5 4.16421 13.8358 4.5 14.25 4.5H18.4395L12.2197 10.7197C11.9268 11.0126 11.9268 11.4874 12.2197 11.7803C12.5126 12.0732 12.9874 12.0732 13.2803 11.7803L19.5 5.56055V9.75C19.5 10.1642 19.8358 10.5 20.25 10.5Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenNew24);

export { ForwardRef as ReactComponent };
//# sourceMappingURL=OpenNew24.svg.js.map
